import { createRouter, createWebHistory } from 'vue-router';
import { auth } from '@/middlewares';
import Layout from '@/themes';

// Auth Pages
const Login = () => import(/* webpackChunkName: "AuthPages" */ '@/pages/Public/Login.vue');
const Register = () => import(/* webpackChunkName: "AuthPages" */ '@/pages/Public/Register.vue');
const Verify = () => import(/* webpackChunkName: "AuthPages" */ '@/pages/Public/VerifyOTP.vue');
const MemberOnboarding = () => import(/* webpackChunkName: "AuthPages" */ '@/pages/Public/MemberOnboarding.vue');
const MemberUpdateProfile = () => import(/* webpackChunkName: "AuthPages" */ '@/pages/Public/MemberUpdateProfile.vue');
const FederatedCallback = () => import(/* webpackChunkName: "AuthPages" */ '@/pages/Public/FederatedCallback.vue');

// Authenticated Pages
const SecuritySetup = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Onboarding/SecuritySetup.vue');
const ProfileSetup = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Onboarding/ProfileSetup.vue');
const AddUser = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Users/AddUser.vue');
const Dashboard = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Dashboard/Dashboard.vue');
const Profile = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Users/Profile.vue');
const Security = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Users/Security.vue');
const ForgotPassword = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Users/ForgotPassword.vue');

const UserList = () => import(/* webpackChunkName: "Users" */ '@/pages/Users/UserList.vue');

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            requiresAuth: true,
            title: 'Dashboard',
          },
        },
        {
          path: '/users',
          name: 'users',
          component: UserList,
          meta: {
            requiresAuth: true,
            title: 'Users',
          },
        },
        {
          path: '/add-user',
          name: 'AddUser',
          component: AddUser,
          meta: {
            requiresAuth: true,
            title: 'Add User',
          },
        },
        {
          path: '/profile',
          name: 'Profile',
          component: Profile,
          meta: {
            requiresAuth: true,
            title: 'Profile Settings',
          },
        },
        {
          path: '/security',
          name: 'Security',
          component: Security,
          meta: {
            requiresAuth: true,
            title: 'Security Settings',
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login',
      },
    },
    {
      path: '/register',
      name: 'Registration',
      component: Register,
      meta: {
        title: 'User Registration',
      },
    },
    {
      path: '/verify',
      name: 'Verify OTP',
      component: Verify,
      meta: {
        title: 'Verify OTP',
      },
    },
    {
      path: '/security-setup',
      name: 'SecuritySetup',
      component: SecuritySetup,
      meta: {
        requiresAuth: true,
        title: 'Security Setup',
      },
    },
    {
      path: '/profile-setup',
      name: 'ProfileSetup',
      component: ProfileSetup,
      meta: {
        requiresAuth: true,
        title: 'Profile Setup',
      },
    },
    {
      path: '/member-onboarding',
      name: 'MemberOnboarding',
      component: MemberOnboarding,
      meta: {
        title: 'Member Onboarding',
      },
    },
    {
      path: '/member-setup',
      name: 'MemberUpdateProfile',
      component: MemberUpdateProfile,
      meta: {
        title: 'Member Update Profile',
      },
    },
    {
      path: '/callback',
      name: 'FederatedCallback',
      component: FederatedCallback,
      meta: {
        title: 'Federated Callback Page',
      },
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        title: 'Forgot Password',
      },
    },
  ],
});

router.beforeEach(async (from, to, next) => {
  return auth(from, to, next);
});

router.afterEach((to) => {
  const defaultDocumentTitle = import.meta.env.VITE_APP_NAME;
  if (to.name) {
    document.title = `${String(to.meta.title)} — ${defaultDocumentTitle}`;
  } else {
    document.title = defaultDocumentTitle;
  }
});

export default router;
